import React from 'react'

import { Input } from '@cvg/react-components'

import { useFiltersContext } from '@contexts/FilterContext'
import { DROPDOWN_COUNTRIES } from '@utils/constants'

const Countries = () => {
  const { filters, setFilter } = useFiltersContext()

  return (
    <Input
      name='countries'
      label='Countries'
      type='multiselect'
      displayOptions={{
        showAllOptions: false,
        showUnselectedLabel: filters.countries.length ? 'Add Country' : 'Show Countries',
        hideUnselectedLabel: 'Hide Unselected Countries'
      }}
      options={DROPDOWN_COUNTRIES}
      selected={filters.countries}
      onSelect={countries => setFilter({ countries })}
    />
  )
}

export default Countries
